import { Dialog, Transition } from "@headlessui/react"
import clsx from "clsx"
import PropTypes from "prop-types"
import { Fragment } from "react"
import NewActionButton from "../../components/Common/NewActionButton"
const SharedDialog = ({
  children,
  className,
  isOpen,
  onClose,
  action,
  actionClassName,
  actionType,
  actionTitle,
}) => {
  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" open={isOpen} onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 z-40 bg-black bg-opacity-50" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-auto z-50 sm:px-4 sm:pt-12">
          <div className="h-full flex items-center justify-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel
                className={clsx(
                  className,
                  "flex flex-col justify-center items-center sm:block w-[800px] max-h-[80%] overflow-auto sm:h-fit pt-10 sm:px-4 md:px-10 sm:pb-4 md:pb-10 sm:rounded-xl bg-white transition-all",
                )}
              >
                <div className="max-h-[500px] w-full overflow-auto px-8">
                  {children}
                </div>
                <div className="flex w-full justify-end gap-4 mt-8">
                  <button
                    className="uppercase text-sm font-medium text-gray4 hover:bg-gray1 rounded-lg p-3"
                    onClick={onClose}
                  >
                    Cancel
                  </button>
                  {action && (
                    <NewActionButton
                      title={actionTitle ?? "add"}
                      action={action}
                      className={actionClassName}
                      actionType={actionType ?? "create"}
                    />
                  )}
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  )
}

SharedDialog.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  action: PropTypes.func,
  actionClassName: PropTypes.string,
  actionType: PropTypes.string,
}

export default SharedDialog
